export default abstract class Pagination
{
    protected regExp: RegExp;

    public constructor()
    {
        this.regExp = new RegExp(/^(.*\/)page-(\d+)\/?$/);
    }

    public getPageNumber(url: string): number
    {
        let matches = this.regExp.exec(url);

        if (matches && matches.length === 3) {
            return Number(matches[2]);
        }

        return 1;
    }

    public deletePageNumberFromUrl(url: string): string
    {
        return url.replace(this.regExp, '$1');
    }

    public trimSlashes(url: string): string
    {
        return url.trim().replace(/^\/?(.*?)\/?$/, '$1');
    }
}
